import ViewAll from "component/design-system/ViewAll";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { useRouter } from "next/router";
import HideIf from "util/HideIf";
import isHomePage from "util/helper/isHomePage";
import { useTranslation } from "next-i18next";
import PartsAvatarVideos from "../videos/Videos";
import styles from "./homeVideoSectionContainer.module.scss";

export default function HomeVideoSectionContainer(props: any) {
  const { highTrafficPageData } = props;
  const router = useRouter();
  const { pathname } = router;
  const { t } = useTranslation("home");

  return (
    <HideIf show={(highTrafficPageData?.All_Categories.H2 && highTrafficPageData?.All_Categories.content) || isHomePage(pathname)}>

      <div className={styles.container}>
        <div className={`d-flex ${styles.title_container}`} style={{ position: "relative" }}>
          <PAText
            bold
            component="h2"
            className={styles.title}
            fontSize={FONT_SIZE[5]}
          >
            {t("Popular PartsAvatar Videos")}
          </PAText>
          <div className={styles.all_manufacturer_view_all}>
            <ViewAll
              href="https://www.youtube.com/@partsavatar"
              title="PartsAvatar Consumer Feedback"
              openNewTab="_blank"
            />
          </div>
        </div>
        <PartsAvatarVideos />
      </div>

    </HideIf>
  );
}
